import { atom } from "jotai";

export const AIFeedbackAtom = atom<boolean>(false);
